import type { GetAdminAccountPaymentDebug200ActiveSubscription } from './getAdminAccountPaymentDebug200ActiveSubscription';
import type { GetAdminAccountPaymentDebug200RecentOrdersItem } from './getAdminAccountPaymentDebug200RecentOrdersItem';
import type { GetAdminAccountPaymentDebug200RecentSubscriptionEventsItem } from './getAdminAccountPaymentDebug200RecentSubscriptionEventsItem';

export type GetAdminAccountPaymentDebug200 = {
  /** @nullable */
  activeSubscription?: GetAdminAccountPaymentDebug200ActiveSubscription;
  currentPlanCode: string;
  recentOrders: GetAdminAccountPaymentDebug200RecentOrdersItem[];
  recentSubscriptionEvents: GetAdminAccountPaymentDebug200RecentSubscriptionEventsItem[];
  userId: string;
};
